import "./detials.css"
function EightServices(){
    return(
        <>
        <div className="servicedetials">
            <div className="row">
               <div className="col-md-12">
<div className="box">
    <i className="fas fa-eye"></i>
    <h4>Ophthalmology and Eye Surgery Unit</h4>
    <p>
        Provides advanced visual examinations including vision testing and retinal imaging, along with surgical treatments for cataracts, LASIK vision correction, and corneal procedures. The team consists of ophthalmology consultants who utilize the latest laser and microscopic devices to ensure precision in operations and patient safety.
    </p>
    <p>July 14, 2025</p>
</div>
</div>
            </div>
           <div className="row  m-2">
  <div className="buttons d-flex">
      <button className="btn w-50 btn-danger m-2">
        <i className="fas fa-times-circle"></i> Return to Service
    </button>
    <button className="btn w-50 btn-warning m-2">
        <i className="fas fa-exclamation-triangle"></i> Return to Service
    </button>
  </div>
</div>
        </div>
        </>
    )
}
export default EightServices